module.exports = __webpack_public_path__ + "static/media/add_account_icon.67c4a031.svg";